import { yup } from '@guiker/yup-util'

export const invitedAssetClaimsSchema = yup.object({
  userId: yup.string().required(),
})

export type InvitedAssetClaims = yup.InferType<typeof invitedAssetClaimsSchema>
